import { request } from '@/services/request';
import type { ReplyData, ReqParams } from '@/pages/api/order/create';

export function createOrder(params: ReqParams): Promise<ReplyData> {
  return request({
    method: 'post',
    url: '/api/order/create',
    data: params,
  }).then((res) => res.data);
}
